<div class="outer-container">

    <lib-title-bar
        [crumbs]="[{ 'label': 'Developer Tools' }, { 'label': 'Webhooks' }, { 'label': 'Event History' }]">
    </lib-title-bar>

    <app-event-history-log-filters
        [filter]="filter"
        (filterChanged)="filterChanged.emit($event)"
        [webhookLookups]="webhookLookups">
    </app-event-history-log-filters>

    <lib-table-base
        class="events-table"
        [columnDefs]="eventsColumnDefs"
        [rowsData]="events"
        [rowsDataLoading]="loading"
        [rowsDataShowWhileLoading]="true"
        [rowsDataError]="error"
        rowsDataErrorMessage="Error Loading Event History"
        [sorting]="sorting"
        (sortingChanged)="onSortingChanged($event)"
        [pager]="pager"
        (pageChanged)="pageChanged.emit($event)"
        selectedRowProperty="token"
        (rowSelected)="onRowSelected($event)">

        <ng-template let-element="element" let-columnId="columnId">
            <app-event-history-table-cell-content
                [columnId]="columnId"
                [element]="element">
            </app-event-history-table-cell-content>
        </ng-template>
    </lib-table-base>

</div>
